import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { AddressDto } from '@digiwall/goliath-contacts/proxy';
import { CountryStore } from '@digiwall/goliath-core';
import { DocRole } from '@digiwall/goliath-core/proxy';

import { Observable } from 'rxjs';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import { AddressDetailComponent } from '@digiwall/core';
import { NgSelectComponent } from '@ng-select/ng-select';
import { AutoSizedDropdownDirective } from '@digiwall/ui-kit';
import { DwNgSelectInputReadonlyDirective } from '@digiwall/ui-kit';
import { ErrorFormControlDirective } from '@digiwall/core';
import { DwInputAutoCompleteDirective } from '@digiwall/core';
import { AsyncPipe } from '@angular/common';
import { LocalizationModule } from '@abp/ng.core';

@Component({
  selector: 'document-doc-supplier-delivery-address',
  templateUrl: './doc-supplier-delivery-address.component.html',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgxValidateCoreModule,
    AddressDetailComponent,
    NgSelectComponent,
    AutoSizedDropdownDirective,
    DwNgSelectInputReadonlyDirective,
    ErrorFormControlDirective,
    DwInputAutoCompleteDirective,
    AsyncPipe,
    LocalizationModule,
  ],
})
export class DocSupplierDeliveryAddressComponent {
  @Input() docForm: FormGroup;
  @Input() addresses$: Observable<AddressDto[]>;
  @Input() docRoleInput: DocRole;
  @Input() showSearch: boolean = true;

  docRole = DocRole;

  countryStore = inject(CountryStore);

  mapTypeId: google.maps.MapTypeId = 'hybrid' as google.maps.MapTypeId;

  constructor() {}

  get deliveryAddressControl() {
    return this.docForm?.get('deliveryAddress') as FormGroup;
  }
}
